import React, {Fragment} from "react";
import {connect} from "react-redux";

import ApplyPopup from "./popups/applyPopup";
import UserPopup from "./popups/userPopup/userPopup";
import ConfirmPopup from "./popups/confirmPopup";
import MessageBox from "./popups/messageBox";
import LoaderView from "./ui/loaderView";
import MobileRotateButton from "./ui/mobileRotateButtonHorizontalNew";
import DocuSignLayer from "./visComponents/docuSignLayer";
import DepositPopup from "./popups/depositPopup";
import AssignQuotePopup from "./popups/assignQuotePopup/assignQuotePopup";
import OrderCompletePopup from "./popups/orderCompletePopup/orderCompletePopup";
// import ContractSigningLayer from "./popups/contractSign/contractSigningLayer";
import CookieMessage from "./common/cookieMessage";
import SuccessNotification from "./ui/successNotification";
import SqftFeaturesPopupWrapper from "./popups/sqftFeaturesPopup/sqftFeaturesPopupWrapper";
import WizardConflictPopup from "./popups/wizardConflictPopup/wizardConflictPopup";
import DiscountAllFinanceOptionsPopup from "./priceWorksheet/discountAllFinanceOptionsPopup";
import CheckoutPopup from "./popups/checkoutPopup";

const Popups = (props) => {

  const {messageBoxState} = props;

  return (
    <Fragment>
      <ApplyPopup/>
      <UserPopup/>
      <ConfirmPopup/>
      <WizardConflictPopup/>
      <MessageBox state={messageBoxState}/>
      <LoaderView/>
      <MobileRotateButton/>
      <DocuSignLayer />
      <DepositPopup />
      <CheckoutPopup />
      <AssignQuotePopup/>
      <OrderCompletePopup/>
      <SqftFeaturesPopupWrapper/>
      {/*{contractSigningVisible ? <ContractSigningLayer /> : null}*/}
      {!document.kvConfig.kioskMode ? <CookieMessage/> : null}
      <SuccessNotification/>
      <DiscountAllFinanceOptionsPopup/>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  return {
    messageBoxState: store.messageBoxState,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Popups)
